import { Dialog, DialogContent, DialogTitle } from '@/components/ui/dialog';
import { Spinner } from '@/components/ui/spinner';

/** The "working on it" overlay a policy or MCE action shows while it runs. */
const LoaderModal = ({ loading, setLoading }: { loading: boolean; setLoading: (loading: boolean) => void }) => (
  <Dialog
    open={loading}
    onOpenChange={(open) => {
      if (!open) setLoading(false);
    }}
  >
    <DialogContent showCloseButton={false} className="flex w-auto items-center justify-center bg-transparent p-8 shadow-none ring-0">
      <DialogTitle className="sr-only">Working</DialogTitle>
      <Spinner className="size-24 text-primary-foreground" />
    </DialogContent>
  </Dialog>
);

export default LoaderModal;
